import { styled } from '../../Utilities';
import { FacepileBase } from './Facepile.base';
import { styles } from './Facepile.styles';
/**
 * The Facepile shows a list of faces or initials in a horizontal lockup. Each circle represents a person.
 */
export var Facepile = styled(FacepileBase, styles, undefined, {
    scope: 'Facepile',
});
//# sourceMappingURL=Facepile.js.map